// extracted by mini-css-extract-plugin
export default {"spotifyContainer":"MusicSection_spotifyContainer__EJKLv"};